import { memo, useEffect, useState } from 'react';
import { AnimationContainer } from '@/sub-luca-plugin/compatible-components';
import { notChooseList, satisfiedList, commentDesc } from './helper';
import { eventBusExample } from '@/sub-luca-plugin/utils/class-example';
import './index.scss';

interface IProps {
    status?: 0 | 1; // 未评价， 已评价
    starLevel?: number; // 选择值
    lucaAskChatId?: string; // luca答疑过来的必传
    askId?: number; // 非luca答的 必传
    onScrollToBottom?: () => void; // 滚动到底部
    canExcuteAimation?: boolean;
}

const QuestionComment = ({ status, starLevel = 0, lucaAskChatId, askId, canExcuteAimation, onScrollToBottom }: IProps) => {
    // 是否评价
    const [streamTips, setStreamTips] = useState(() => (status === 1 ? '很高兴收到你的反馈，如果你还有其他问题，随时向我提问！' : ''));
    const [endTips, setEndTips] = useState(() => (status === 1 ? '本次答疑服务已结束，感谢你的咨询' : ''));

    // 流式执行回调
    const streamReturnContent = async (content: string, callback: (content: string) => void) => {
        if (!content) return;
        let index = 0;
        let currentContent = '';
        return new Promise(resolve => {
            const timer = setInterval(() => {
                if (index >= content.length) {
                    clearInterval(timer);
                    resolve('end');
                } else {
                    currentContent += content[index];
                    callback(currentContent);
                }
                index++;
            }, 50);
        });
    };

    const handleChoose = (starLevel: number) => {
        eventBusExample.publish('EvaluteModal', { type: 'open', params: { lucaAskChatId, askId, starLevel } });
    };

    const handleAnimationendOfEmoticon = async () => {
        await streamReturnContent('很高兴收到你的反馈，如果你还有其他问题，随时向我提问！', content => {
            setStreamTips(content);
        });
        setEndTips('本次答疑服务已结束，感谢你的咨询');
    };

    useEffect(() => {
        if (streamTips || endTips) {
            onScrollToBottom?.();
        }
    }, [streamTips, endTips]);

    if (status !== 1) {
        return (
            <div className="satisfied-box">
                <div className="comment-tip" style={{ color: '#FF6813' }}>
                    问题的解答满意吗
                </div>

                <div className="expression-list">
                    {notChooseList.map((item, index) => (
                        <div key={item} className="expression-container">
                            <img className="expression-icon" src={item} onClick={() => handleChoose(index + 1)} />
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className="satisfied-box">
            <div className="comment-tip" style={{ color: '#A5A5A5' }}>
                问题的解答满意吗
            </div>
            <div className="handle-comment">
                <AnimationContainer
                    type="jitter_up_and_down"
                    animationend={handleAnimationendOfEmoticon}
                    canExcuteAimation={canExcuteAimation}
                >
                    <img src={satisfiedList[starLevel - 1]} />
                </AnimationContainer>
                <span>{commentDesc[starLevel - 1]}</span>
            </div>
            {streamTips && <div className="comment-tip-card">{streamTips}</div>}
            <AnimationContainer type={endTips ? 'fade_in' : undefined} canExcuteAimation={canExcuteAimation}>
                <div className="comment-tip-text">{endTips}</div>
            </AnimationContainer>
        </div>
    );
};

export default memo(QuestionComment);
